export default __webpack_public_path__ + "static/media/Dragon.8f0d34cd.png";